module.exports = __webpack_public_path__ + "img/bg3.3065fdd1.png";